<template>
  <l-modal :showing="showing" text="Exceedance Descriptions" icon="edit" color="bg-orange-500" @close="close">
    <div class="w-full text-xs" v-if="editObj.id">
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Exceedance ID</b>
          <br />
          <l-input
            v-model="editObj.id"
            inputClass="text-2xs"
            :disabled="!this.isnew"
          ></l-input>
        </div>
        
        <div class="w-1/2">
          <b>Attainment</b>
          <br />
          <l-select
            v-model="editObj.attainment_id"
            class="text-xs"
            :data="attainments"
            :multiple="false" @change="updateExceedingData"
          >
            <l-option
              v-for="i in attainments"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
      </div>

      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Exceedance Description Method</b>
          <br />
           <l-select
            v-model="editObj.exceedancedescription_element"
            class="text-xs"
            :data="exceedancedescriptionelements"
            :multiple="false"
          >
            <l-option
              v-for="i in exceedancedescriptionelements"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
        <div class="w-1/2">         
         <b>Exceedance?</b>
          <br />
          <input v-model="editObj.exceedances" type="checkbox" class="bigCheckbox" />     
        </div>
      </div>
   
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Excedance Type</b>
          <br />
           <l-select
            v-model="editObj.excedance_type"
            class="text-xs"
            :data="exceedancetype"
            :multiple="false"
          >
            <l-option
              v-for="i in exceedancetype"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
        <div class="w-1/2">
          <b>Excedance Value</b>
          <br />
          <l-input
            type="number"
            v-model="editObj.max_value"
            inputClass="text-2xs"
          ></l-input>
        </div>
      </div>

      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Area Classification</b>
          <br />
          <l-select
            v-model="editObj.area_classification"
            class="text-xs"
            :data="areaclassifications"
            :multiple="false"
          >
            <l-option
              v-for="i in areaclassifications"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
        <div class="w-1/2">
          <b>Adjustment Type</b>
          <br />
          <l-select
            v-model="editObj.adjustment_type"
            class="text-xs"
            :data="adjustmenttypes"
            :multiple="false"
          >
            <l-option
              v-for="i in adjustmenttypes"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>          
        </div>
      </div>      
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Exceedance Reason</b>
          <br />
          <l-select
            v-model="editObj.exceedance_reason"
            class="text-xs"
            :data="exceedancereason"
            :multiple="false"
          >
            <l-option
              v-for="i in exceedancereason"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>           
        </div>
        <div class="w-1/2">
          <b>Other Exceedance Reason</b>
          <br />
          <l-input
            placeholder="Enter 'other exceedance reason'"
            v-model="editObj.other_exceedance_reason"
            inputClass="text-2xs"
          ></l-input>
        </div>
      </div>  
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Surface Area </b>[in m<sup>2</sup>]
          <br />
          <l-input
            type="number"
            v-model="editObj.surface_area"
            inputClass="text-2xs"
          ></l-input>
        </div>
        <div class="w-1/2">
          <b>Vegetation Area </b>[in m<sup>2</sup>]
          <br />
          <l-input
            type="number"
            v-model="editObj.vegetation_area"
            inputClass="text-2xs"
          ></l-input>
        </div>
      </div>  
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Number of exposed population</b>
          <br />
          <l-input
            v-model="editObj.exposed_population"
            inputClass="text-2xs"
          ></l-input>
        </div>
        <div class="w-1/2">
          <b>Population Reference Year</b>
          <br />
          <l-input
            placeholder="Enter 'Population Reference Year'"
            v-model="editObj.population_reference_year"
            inputClass="text-2xs"
          ></l-input>
        </div>
      </div>  

      <div class="w-full flex mb-4">
        <div class="w-full">
          <b>Exceeding Methods</b>
          <span style="display:none">{{attainment}} </span>
          <br />
          <div class="checkboxList" >
            <div v-for='ad in this.exceedingDataBox' :key='ad.assessmentdata_id' class="flex" >
              <div class="w-1/2">
                <label >
                  <input v-model="ad.selected" type="checkbox" :id="ad.assessmentdata_id" />
                  {{ ad.existingexceedingmethod }} 
                </label>
              </div>           
            </div>
          </div>
        </div>
      </div>

      <div class="flex w-full justify-between">
        <l-button type="success" @click="onSave">Save changes</l-button>
        <l-button type="danger" @click="close">Cancel</l-button>
      </div>
    </div>
  </l-modal>
</template>

<script>
import LModal from "@/components/LModal";
import { LInput, LButton, LSelect, LOption } from "@/components/forms";
import ExceedanceDescriptionsService from "./exceedanceDescriptions.service";

export default {
  name: "LLEdit",
  props: [
    "showing", 
    "attainments", 
    "exceedancedescriptionelements", 
    "exceedancetype", 
    "areaclassifications", 
    "adjustmenttypes", 
    "exceedancereason",
    "exceedingdataAll",
    "selected", 
    "isnew"
  ],
  components: {
    LModal,
    LInput,
    LButton,
    LSelect,
    LOption
  },
    data() {
      return {
        attainmentId: '0',
        exceedingdata: []
    };
  },
  computed: {
    editObj: function() {
      return Object.assign({}, this.selected);
    },
    attainment:  function(){

      if (this.showing == true)
      if(!!this.editObj.attainment_id) {
        this.attainmentId = this.editObj.attainment_id.substr(this.editObj.attainment_id.lastIndexOf('/')+1);
        return this.attainmentId;
      } else return null;
    },
    exceedingDataBox: function(){ 
        if (!this.exceedingdataAll) return null;
        let att_id = this.attainmentId;
        this.exceedingdata =  this.exceedingdataAll.filter(function(ad) {
            return ad.attainmentid == att_id;
          });
        let id = this.editObj.id
        this.exceedingdata.forEach(function(part, index) {
          !!this[index].id && this[index].exceedancedescription_id == id ?  this[index].selected = true : false;
        }, this.exceedingdata); 
        return this.exceedingdata;
    },
    componentUsed: function() {
       return new Set(this.exceedingdataAll.map(x=>x.attainment_name));
    },
  },
  methods: {
    updateExceedingData() {
      this.attainmentId = this.editObj.attainment_id.substr(this.editObj.attainment_id.lastIndexOf('/')+1);

        },
    close() {
      this.$emit("close");
    },
    onSave() {
      this.editObj.exceedances = this.editObj.exceedances ? '1' : '0';

      let dataUpdate =  this.exceedingdata.filter(function(ad) {
            return ad.selected;
          });
      let id = this.editObj.id;
      dataUpdate.forEach(function(part, index) {
        this[index].exceedancedescription_id = id;
      }, dataUpdate); 

  
      let dataDelete =  this.exceedingdata.filter(function(ad) {
            return !ad.selected && !!ad.exceedancedescription_id;
          }).map(x=>x.id);
      this.$emit("save", {exceedingdesc: this.editObj, dataUpdate: dataUpdate, dataDelete: dataDelete});
      this.close();
    }
  }
}
</script>
<style lang="postcss">
.bigCheckbox {
    width: 70px;
    height: 16px;
    margin-top: 6px;
}
.checkboxList {
  overflow-y: scroll; padding: 10px; border-color: #a0aec0; border-radius: 0.25rem; border-width: 1px; height: 172px;
}
 .checkboxList div label{
  vertical-align: -webkit-baseline-middle;
} 
span.ls {
  letter-spacing: -1px;
  padding-left: 0;
}

</style>